<template>
    <div id="container">
        <div class="backstep" @click="nameReturn">
            <i class="fas fa-long-arrow-alt-left"></i>
        </div>
        <h2>{{trad.pagePhone.titlePhone}}</h2>
        <vue-tel-input v-model="phone" placeholder="..." v-bind="bindProps"></vue-tel-input>
        <div class="error-msg">
            <h2><i class="fas fa-exclamation-circle"></i>{{trad.pagePhone.errorPhone}}</h2>
        </div>
        <br>
        <button @click="phoneChecked">{{trad.pagePhone.button}}</button>
        <br>
        <img :src="help[randPic]" alt="Help-pic">
        <div class="help-container">
            <div class="talk-bubble tri-right round btm-left">
                <div class="talktext">
                    <p>{{trad.pagePhone.help}}</p>
                </div>
            </div>
        </div>

    </div>
</template>

<script>

import { VueTelInput } from 'vue-tel-input';

export default {
    name: "WelcomePhoneCheck",
    components: {
        VueTelInput,
    },
    data() {
        return {
            phone: '',
            checked: false,
            trad: this.langTxt,
            bindProps: {
                mode: "international",
                defaultCountry: "FR"
            },
            help: ["help0.png","help1.png","help2.png","help3.png","help4.png"]
        }
    },
    props: ["demoProgression", "randPic","langTxt"],
    created: function() {
            window.scrollTo(0,document.body.scrollHeight);
            if(localStorage['phone']) {
                this.phone = localStorage['phone']
            }
            else {
                return false
            }
    },
    methods: {
        phoneChecked(e) {
            let phoneVerif = parseInt(this.phone)
            if(this.phone.length > 5 && phoneVerif)
            {
            e.preventDefault();

            this.checked = true;

            this.demoProgression[0].phone = this.phone;
            this.demoProgression[0].completedPhone = this.checked;

            // Progression bar
            this.$emit('phone-checked', this.demoProgression);

            // Stock in local browser
            localStorage.setItem('phone', this.phone);
            }

            else
            {
                let errorMsg = document.querySelector(".error-msg")
                errorMsg.classList.add("error-show");
            }
        },
        nameReturn() {
            if(this.demoProgression[0].completedMail)
                {
                    this.demoProgression[0].demoStart = true;
                    this.demoProgression[0].completedMail = true;
                    this.demoProgression[0].completedName = false;
                    this.demoProgression[0].completedPhone = false;
                    this.demoProgression[0].sendClicked = false;
                    this.demoProgression[0].preview = false;
                }
        }
    }
}
</script>

<style scoped>
    #container {
        padding: 50px;
        padding-top: 35px;
        box-shadow: 10px 10px 20px 0px rgba(133,133,133,0.55);
        margin: auto;
        width: fit-content;
        height: 480px;
        margin-top: 15px;
        border-radius: 10px;
        position: relative;
    }

    /* Start Phone Module (see js to modify css) */

    .vue-tel-input {
        border-radius: 10px !important;
        border: none;
        width: 375px;
        height: 40px;
        box-shadow:#e6e6e6 4px 4px 8px;
        background-color: rgb(250, 250, 250);
        font-size: 18px;
        font-weight: bold;
        text-align: center;
        color: rgb(59, 59, 59);
    }

    /* !dm @ 20210106 */
    /* 
        ### IMPORTANT
        ### After updating the app in 2021 the 'vue-tel-input' component was changed and looked diferent, to modify please compile the release using 'npm run build' and then replace the OLD with the NEW from the 'dist\js\chunk-vendors.xxxxxxxx.js' file:
        OLD : .vti__input{border:none;border-radius:0 2px 2px 0;width:100%;outline:0;padding-left:7px}
        NEW : .vti__input{border:none;background-color: rgb(250, 250, 250);border-radius:10px;width:100%;outline:0;padding-left:7px;font-size:16px;font-weight:bold}
    */

    /* End Phone Module (see js to modify css) */

    button {
        padding: 8px;
        background-color: #3F608E;
        color: white;
        font-size: 20px;
        font-weight: bold;
        border-radius: 10px;
        margin-top: 25px;
        cursor: pointer;
        border: none;
        z-index: 100;
        font-family: Avenir, Helvetica, Arial, sans-serif;
    }
    button:hover {
        transition-duration: 0.8s;
        background: #7C9048;
    }
    h2 {
        margin: 25px;
        margin-top: 35px;
    }

    /* Start Error Message */

    .error-msg {
        display: none;
    }
    .error-show {
        display: flex !important;
        justify-content: center;
        align-items: center;
        font-size: 10px;
        position: absolute;
        top: 37%;
        left: 0;
        width: 100%;
        display: flex;
        justify-content: center;
        color: rgb(167, 167, 167);
    }
    .error-show h2{
        padding: 0;
        margin: 0;
    }

    /* End Error Message */

    /* Start Help User */

    .help-container {
        position: absolute;
        width: fit-content;
        height: fit-content;
        bottom: 95px;
        left: 90px;
    }
    img {
        width: 125px;
        position: absolute;
        left: -5px;
        bottom: -15px;
    }
    .talk-bubble {
        display: inline-block;
        position: relative;
        width: 300px;
        height: auto;
        background-color: #f9f9db;
    }
    .border{
        border: 8px solid #666;
    }
    .round{
        border-radius: 30px;
        -webkit-border-radius: 30px;
        -moz-border-radius: 30px;
    }
    .tri-right.border.btm-left:before {
        content: ' ';
        position: absolute;
        width: 0;
        height: 0;
        left: -8px;
        right: auto;
        top: auto;
        bottom: -40px;
        border: 32px solid;
        border-color: transparent transparent transparent #666;
    }
    .tri-right.btm-left:after{
        content: ' ';
        position: absolute;
        width: 0;
        height: 0;
        left: 0px;
        right: auto;
        top: auto;
        bottom: -20px;
        border: 22px solid;
        border-color: transparent transparent transparent #f9f9db;
    }
    .talktext{
        padding: 1em;
        text-align: left;
        line-height: 1.5em;
    }
    .talktext p{
        -webkit-margin-before: 0em;
        -webkit-margin-after: 0em;
        font-weight: 500;
    }

     /* End Help User */
   

    @media screen and (max-width: 800px) {
        #container {
            width: 100%;
        }
        .vue-tel-input{
            width: 100%;
        }
        .talk-bubble {
            width: 225px;
        }
        img {
            z-index: -2;
        }
    }

    @media screen and (max-width: 475px) {
        #container{
            width: 100%;
            height: 70vh;
        }
        .error-show {
            top: 32%;
        }
    }

    @media screen and (max-width: 457px) {
        #container{
            width: 100%;
            height: 70vh;
        }
        .error-show {
            top: 38%;
        }
    }


    @media screen and (max-width: 375px) and (max-height: 680px) {
        #container{
            width: 100%;
            height: 80vh;
        }
        .error-show {
            top: 38%;
        }
    }

    @media screen and (max-width: 325px) and (max-height: 600px) {
        #container {
            width: 100%;
            height: 90vh;
        }
        .error-show {
            top: 38%;
        }
    }
</style>